import React from "react"
import { Badge } from "../ui/badge"

interface Props {
  service_details: any
  is_group_service: boolean
  service: any

  getPrice: any
  getUnits: any
  getRecurrenceSchedule: any
  getStartDates: any

  recurrenceTriggerRef: any
  recurrencePopoverRef: any
  showRecurrencePopover: boolean
  setShowRecurrencePopover: React.Dispatch<React.SetStateAction<boolean>>
}

const ServiceCardTitlePrice: React.FC<Props> = ({
  service_details,
  is_group_service,
  service,
  getPrice,
  getUnits,
  getRecurrenceSchedule,
  getStartDates,
  recurrenceTriggerRef,
  recurrencePopoverRef,
  showRecurrencePopover,
  setShowRecurrencePopover,
}) => {

  return (
    <>
      <div className="w-full h-[115px] flex flex-col px-2 sm:px-[8px]">
        <div className="flex justify-between items-center]">
          <div
            className={`font-bold break-words flex-1 ${
              service_details?.title?.length > 73
                ? "text-[12px]"
                : "text-[18px]"
            }`}
          >
            {service_details?.title}
          </div>
          <div className="flex flex-col items-end ml-4">
            <div className="flex items-center">
              <h3 className="font-bold text-lg sm:text-[22px] text-blurple">
                {getPrice(parseInt(service_details?.billing?.amount))}
              </h3>
              <span
                className={`text-graySlate text-base font-normal mt-1 sm:ml-2 sm:mt-0 ${
                  ["month", "year", "week"].includes(
                    service_details?.billing.unit
                  )
                    ? "whitespace-nowrap"
                    : "md:whitespace-nowrap"
                }`}
              >
                {getUnits(
                  service_details.billing.unit,
                  parseInt(service_details?.billing?.amount),
                  service_details?.type
                )}
              </span>
            </div>
          </div>
        </div>
        {is_group_service && (
          <>
            {service?.service_details.type === "recurring"
              ? (() => {
                  const recurrenceMessages =
                    getRecurrenceSchedule().recurrenceMessage
                  return recurrenceMessages.length > 1 ? (
                    <div className="mt-2">
                      <button
                        ref={recurrenceTriggerRef}
                        className="text-blurple text-sm font-bold"
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          setShowRecurrencePopover((prev) => !prev)
                        }}
                      >
                        Click here to see scheduled dates
                      </button>
                      {showRecurrencePopover && (
                        <div
                          ref={recurrencePopoverRef}
                          className="absolute z-10 mt-2 p-3 bg-white border rounded shadow-md whitespace-nowrap"
                        >
                          {recurrenceMessages.map(
                            (msg: string, idx: number) => (
                              <div
                                key={idx}
                                className="mb-1 font-normal text-sm"
                              >
                                {msg}
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="mt-2">
                      <Badge variant="secondary">{recurrenceMessages[0]}</Badge>
                    </div>
                  )
                })()
              : getStartDates().startMessage && (
                  <div className="mt-2">
                    <Badge variant="secondary">
                      {getStartDates().startMessage}
                    </Badge>
                  </div>
                )}
          </>
        )}
      </div>
    </>
  )
}

export default ServiceCardTitlePrice
